import { MarkdownToolbars } from '@efdigital/ll-addon-codemirror';
// import { ResourceTemplate } from '@efdigital/ll-addon-content';
import { type Resource } from '@efdigital/ll-addon-data';
import { DataTypeContent } from '@efdigital/ll-addon-data/data-types/content';
import { ArrayFirst, debounce } from '@efdigital/ll-addon-ui';
import { MarkdownEditorWithImagePicker } from '@efdigital/ll-admin-v2/components/markdown-editor-with-image-picker';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import type { ComponentLike } from '@glint/template';
import { withReactiveResponse } from '@warp-drive/core/request';
import { Request } from '@warp-drive/ember';
import { query } from '@warp-drive/utilities/json-api';

import { jsonApiOptions } from '../lib/json-api.ts';

const FirstResource = ArrayFirst as ComponentLike<{
  Args: {
    data: Array<Resource>;
  };
  Blocks: {
    item: [Resource];
    empty: [];
  };
}>;

export default class ResourceRoute extends Component<{
  Args: {
    model: {
      id: string;
    };
  };
}> {
  myQuery() {
    return withReactiveResponse<Resource[]>(
      query(
        DataTypeContent.Resource,
        {
          'filter[slug]': 'project-matrix-organizations',
          'page[limit]': '1',
          include: ['contacts'],
        },
        jsonApiOptions
      )
    );
  }

  updateTitle = (resource: Resource, event: Event) => {
    const target = event.target as HTMLInputElement;
    resource.title = target.value;
  };

  updateMarkdown = (resource: Resource, value: string) => {
    resource.markdown = value;
  };

  <template>
    <Request @query={{(this.myQuery)}}>
      <:content as |response|>
        <FirstResource @data={{response.data}}>
          <:item as |resource|>
            <div class="container">
              <div class="card">
                <div class="card-body">
                  <p>Title:
                    <input
                      type="text"
                      value={{resource.title}}
                      {{debounce (fn this.updateTitle resource)}}
                      aria-label="Title"
                    /></p>
                  <p>Short name:{{resource.slug}}</p>
                  <p>Template:{{resource.template}}</p>
                  <img
                    src={{resource.icon}}
                    alt={{resource.title}}
                    width="200"
                  />
                </div>
              </div>
            </div>

            <MarkdownEditorWithImagePicker
              @markdown={{resource.markdown}}
              @toolbar={{MarkdownToolbars.All}}
              @onUpdate={{fn this.updateMarkdown resource}}
              @requiredSize="email-image"
            >
              <:preview as |markdown|>
                <pre>{{markdown}}</pre>
              </:preview>
            </MarkdownEditorWithImagePicker>

            <div class="container">
              {{!-- <ResourceTemplate @model={{resource}} @parts={{parts}} /> --}}
            </div>
          </:item>
          <:empty>
            <div class="container">
              <h1>No resource found</h1>
            </div>
          </:empty>
        </FirstResource>
      </:content>
      <:loading>
        <div class="container">
          <h1>Loading...</h1>
        </div>
      </:loading>
      <:error as |error state|>
        <div class="container">
          <p>Error: {{error.message}}</p>
          <p><button
              type="button"
              class="btn btn-primary"
              {{on "click" state.retry}}
            >Try Again?</button></p>
        </div>
      </:error>
    </Request>
  </template>
}
